<template>
  <div id="Services" class="Page Services" v-if="response">

    <section id="Top" class="Section Banner" :style="`background-image: url('${response[0].primary.intro_background.url}')`">
      <div class="Banner_wrapper" >
        <div class="Banner_content" >
          <div class="Banner_text">
            <h2>{{ response[0].primary.intro_title }}</h2>
          </div>
        </div>
      </div>
    </section>

    <section class="Section Prestation">
     <div class="Prestation_wrapper">
        <div class="Prestation_content">
          <img src="/assets/images/wave-top.svg"/>
          <h3>{{ response[1].primary.our_brand_label }}</h3>
          <h2>{{ response[1].primary.our_brand_title }}</h2>
          <p>
            <!-- <a v-for="(link, i) in data.sections[0].links" :key="i" :href="link.href" v-html="link.label" target="_blank"></a> -->
            <span v-for="(link, i) in response[1].items" :key="i" v-html="link.our_brand_brands"></span>
          </p>
          <img src="/assets/images/wave-down.svg"/>
        </div>

        <div class="Presta_list" >
          <PrestaCard @anchor="scrollToElt" v-for="(service, i) in getPrestation" :key="i" :data="service"/>
        </div>

      </div>
  </section>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"
import prismicFetch from "@/mixins/prismicFetch";
import PrestaList from "@/components/PrestaList"
import ScrollParallax from "@/components/ScrollParallax"
import Fade from "@/components/Fade"
import Footer from "@/components/partials/Footer"
import PrestaCard from "@/components/PrestaCard"

export default {
  components: {
    PrestaList,
    ScrollParallax,
    Fade,
    PrestaCard,
    Footer
  },
  mixins: [ page, prismicFetch ],
  data () {
    return {
      data: null
    }
  },
  head: {
    title: {
      inner: "So Beautiful By Sarah",
      separator: '/',
      complement: 'Services'
    }
  },
    computed: {
      getPrestation () {
          return this.response.slice(2)
      }
    },
  methods: {
    setData (data) {
      this.data = data
      this.$nextTick( () => {
        document.dispatchEvent(new Event('render-trigger'))
      })
    },
    scrollToElt(e) {
      // console.log("ANCRE parent", e)

      var isSafari = document.body.classList.contains('safari')
      console.log("safari", isSafari)

      if (isSafari) {
        setTimeout(() => {
          var top = e.getBoundingClientRect().y - 100
          console.log("top", top)
          console.log("scroll", window.scrollTo(0, top))
          window.scrollTo(0, e.getBoundingClientRect().y - 100)
          console.log("scrollTop",e)
          e.scrollIntoView()
        }, 200);
      } else {
        console.log("not safari")
        setTimeout(() => {
          console.log("scroll", window.scrollTo({ top: e.getBoundingClientRect().y - 100, behavior: 'smooth' }))

          window.scrollTo({ top: e.getBoundingClientRect().y - 100, behavior: 'smooth' })
        }, 200);
      }

    }
  },
    created() {
      this.getContent('services')
    }
}
</script>

<style lang="stylus" scoped>
.Services

  .Banner
    background-position 50% 50%
    background-repeat no-repeat
    background-size cover
    height 500px
    color $beige

    @media $medium
      height 300px

    @media $xsmall
      height 200px
      background-position center 25px

    &_wrapper
      height 100%

    &_content
      position relative
      top 50%
      transform translateY(-50%)
      text-align center

  .Prestation
    padding-top 60px

    @media $xsmall
      padding-top 30px

    &_wrapper
      width 90%
      max-width $max-width
      margin 0 auto

    &_content
      width 500px
      margin 0 auto
      text-align center
      padding-bottom 50px
      color $dark-brown

      @media $small
        width 90%

      @media $xsmall
        padding-bottom 30px

      h3
        color $light-brown

      img
        position relative
        width 350px

        &:first-child
          left 90px
          top 20px
          transform translateY(-20px)

          @media $xsmall
            left 50px

        &:last-child
          right 90px
          top 20px
          transform translateY(-20px)

          @media $xsmall
            right 50px

        @media $small
          width 250px

        @media $xsmall
          width 200px

      p
        margin-bottom 30px

      a, span
        color $dark-brown
        display block
        margin-bottom 5px

        // &:hover
        //   color $light-brown


.Presta

  &_list
    column-count 2
    position relative
    text-align center
    padding-top 80px
    padding-bottom 40px

    @media $small
      padding-top 60px

    @media screen and (max-width: 767px)
      column-count 1
      padding-top 40px

    &:before
      content:''
      height 1px
      position absolute
      left 50%
      transform translateX(-50%)
      color $dark-brown
      background-color $dark-brown
      opacity .3

    &:before
      top 0
      width 30%
</style>
